module.exports = __webpack_public_path__ + "static/media/dream_compass_lock67228969c584779135f8f97891c9b2e8.webp";